import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ruleBuilderLabel: {
    description: 'Label for the insurance rule builder section',
    defaultMessage: 'Automatically apply insurance when:',
    id: 'fzCt7W',
  },
  criteriaOrderTotal: {
    description: 'Criteria option for order total',
    defaultMessage: 'Order Total',
    id: 'ec36co',
  },
  operatorGreaterThan: {
    description: 'Operator option for greater than comparison',
    defaultMessage: 'is greater than',
    id: 'r5fj6R',
  },
  operatorLessThan: {
    description: 'Operator option for less than comparison',
    defaultMessage: 'is less than',
    id: 'sOedIW',
  },
  operatorEqualTo: {
    description: 'Operator option for equal to comparison',
    defaultMessage: 'is equal to',
    id: '1aqu6i',
  },
  operatorGreaterThanOrEqual: {
    description: 'Operator option for greater than or equal to comparison',
    defaultMessage: 'is greater than or equal to',
    id: 'sJSk4J',
  },
  operatorLessThanOrEqual: {
    description: 'Operator option for less than or equal to comparison',
    defaultMessage: 'is less than or equal to',
    id: 'jjoZ/0',
  },
  saveButton: {
    description: 'Save button text for insurance rule builder',
    defaultMessage: 'Save',
    id: 'CPIZ4i',
  },
  editButton: {
    description: 'Edit button text for saved insurance rule',
    defaultMessage: 'Edit',
    id: 'jGdD/R',
  },
});
